export default __webpack_public_path__ + "static/media/library-6.84dfafec.webp";